import { GetChatMessagesResponse } from '../../interfaces/api/qna';
import { api } from '../api';
import http from '../http';
import { ShareResponse } from '../../interfaces/api/content/share';

/**
 * Chat sharing service
 * Provides methods for sharing chats and retrieving shared chat history
 */
export const share = {
  /**
   * Shares a chat with others by creating a public link
   * @param {string} id - ID of the chat to share
   * @returns {Promise<ShareResponse>} Promise resolving to share response with link data
   */
  shareChat: (id: string): Promise<ShareResponse> =>
    new Promise((resolve, reject) => {
      http
        .post(api.qna.share + id, {})
        .then((res) => resolve(res as ShareResponse))
        .catch((e) => reject(e));
    }),

  /**
   * Retrieves message history for a shared chat
   * @param {string} [id] - ID of the shared chat to retrieve
   * @returns {Promise<GetChatMessagesResponse>} Promise resolving to chat messages
   */
  getChatHistory: (id?: string): Promise<GetChatMessagesResponse> =>
    new Promise((resolve, reject) => {
      const url = `${api.qna.publicChat}${id}?length=50&start=0`;
      http
        .get(url)
        .then((res) => resolve(res as GetChatMessagesResponse))
        .catch((e) => reject(e));
    }),
};
